/**
 * Waits for a 'pageView' event to occur in the `window.adobeDataLayer`.
 *
 * This function returns a promise that resolves when a 'pageView' event is detected.
 * If the event has already occurred, the promise resolves immediately.
 * Otherwise, it sets up a listener to resolve the promise when the event occurs.
 *
 * @returns {Promise<void>} A promise that resolves when a 'pageView' event is detected.
 *
 * @example
 * await waitForPageView();
 * // Continue logic after pageView event
 */
export function waitForPageView(): Promise<void> {
  let pageViewResolved!: () => void;
  const pageViewPromise = new Promise<void>(resolve => {
    pageViewResolved = resolve;
  });

  if (window.adobeDataLayer?.length) {
    for (const event of window.adobeDataLayer) {
      if (event.event === 'pageView') {
        pageViewResolved();
      }
    }
  } else {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push(function (dl: any) {
      dl.addEventListener('pageView', () => {
        pageViewResolved();
      });
    });
  }

  return pageViewPromise;
}
